import React, { Component } from 'react';
import { NativeModules, StyleSheet, Text, View, Platform } from 'react-native';
import SendIntentAndroid from 'react-native-send-intent';
import i18n from 'i18next';
import { RadioButtonGroup } from 'fitbeat.react-native-components';
import { scale } from 'react-native-size-matters';
const { EliteDevToggle, EliteUpdate } = NativeModules;
import { Theme } from '../../theme'
import { ENVIRONMENT, environmentToggler, build, overrideConfig, getConfig } from '../../config';
import { setupStripe } from '../../utils/setupStripe';
import Storage from '../../utils/Storage';
import { Button } from '../../components';
import { ScrollView } from 'react-native-gesture-handler';
import { cycleEnumValues } from './utils';

const toggleButtonFontSize = 12;

// Copy of enum AudioScenarioType from react-native-agora
const AudioScenarioType = {
  AudioScenarioDefault: 0,
  AudioScenarioGameStreaming: 3,
  AudioScenarioChatroom: 5,
  AudioScenarioChorus: 7,
  AudioScenarioMeeting: 8,
  AudioScenarioNum: 9,
};

// Copy of enum AudioProfileType from react-native-agora
const AudioProfileType = {
  AudioProfileDefault: 0,
  AudioProfileSpeechStandard: 1,
  AudioProfileMusicStandard: 2,
  AudioProfileMusicStandardStereo: 3,
  AudioProfileMusicHighQuality: 4,
  AudioProfileMusicHighQualityStereo: 5,
  AudioProfileIot: 6,
  AudioProfileNum: 7,
};

const findDefaultIndex = (audioSetting, defaultConfigValue) =>
  Object.values(audioSetting).findIndex(
    (value) => defaultConfigValue === value
  );

const cycleAgoraAudioProfiles = cycleEnumValues(
  AudioProfileType,
  findDefaultIndex(AudioProfileType, getConfig().agoraStreamingAudioProfile),
);
const cycleAgoraAudioScenarios = cycleEnumValues(
  AudioScenarioType,
  findDefaultIndex(AudioScenarioType, getConfig().agoraStreamingAudioScenario),
);

export class DevToggles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateChannel: 'unknown',
    };
  }

  componentDidMount = async () => {
    if (EliteUpdate && EliteUpdate.getUpdateChannel) {
      try {
        const updateChannel = await EliteUpdate.getUpdateChannel();
        this.setState({ updateChannel: updateChannel.name });
      } catch { /* no-op */ }
    }
  };

  openSettings() {
    SendIntentAndroid.openSettings('android.settings.SETTINGS');
  }

  lockTask() {
    if (EliteDevToggle && EliteDevToggle.lockTask) {
      EliteDevToggle.lockTask();
    }
  }

  unlockTask() {
    if (EliteDevToggle && EliteDevToggle.unlockTask) {
      EliteDevToggle.unlockTask();
    }
  }

  async resetEliteSetup() {
    await Storage.remove('eliteDeviceIsSetup');
    if (EliteDevToggle && EliteDevToggle.resetSetup) {
      EliteDevToggle.resetSetup();
    }
  }

  toggleEliteUpdateChannel = async () => {
    if (EliteUpdate && EliteUpdate.getUpdateChannel && EliteUpdate.setUpdateChannel) {
      try {
        const previousChannel = await EliteUpdate.getUpdateChannel();
        const updateChannel = await EliteUpdate.setUpdateChannel(!previousChannel.stable);

        this.setState({
          updateChannel: updateChannel.name,
        });
      } catch { /* no-op */ }
    }
  };

  workoutSpeedChanged = (value) => {
    overrideConfig({ workoutPlaybackSpeed: Number(value) });
    this.props.onChange();
  }

  cycleAgoraStreamingAudioProfile = () => {
    overrideConfig({ agoraStreamingAudioProfile: cycleAgoraAudioProfiles() });
    this.setState({});
  };

  cycleAgoraStreamingAudioScenario = () => {
    overrideConfig({ agoraStreamingAudioScenario: cycleAgoraAudioScenarios() });
    this.setState({});
  };

  changeGenericDuckedVolume = (currentValue) => {
    const incrementedNumber = parseFloat(((currentValue + 0.05) % 1).toFixed(2));
    overrideConfig({ streamingWorkoutDuckedVolume: incrementedNumber });
    this.setState({});
  };

  changeStreamingWorkoutBeepAndVoiceVolume = (currentValue) => {
    overrideConfig({ streamingWorkoutBeepAndVoiceVolume: (currentValue + 5) % 100 });
    this.setState({});
  };

  changeStreamingGenericMusicVolume = (currentValue) => {
    const incrementedNumber = parseFloat(((currentValue + 0.05) % 1).toFixed(2));
    overrideConfig({ streamingWorkoutVolume: incrementedNumber });
    this.setState({});
  };

  render() {
    const changeHelper = this.props.changeHelper || setupStripe;

    const setEnvironment = async (name) => {
      await environmentToggler.set(name, changeHelper);
      this.props.onChange(name);
    };

    const reset = async () => {
      await environmentToggler.reset(changeHelper);
      this.props.onChange('reset');
    };

    const buildOption = option => {
      return {
        name: `${option.display} (${option.id})`,
        isSelected: ENVIRONMENT.name === option.id,
        setOption: () => { setEnvironment(option.id); },
      };
    };

    const buildLocaleOption = (name) => {
      return {
        name,
        isSelected: i18n.language === name,
        setOption: () => { i18n.changeLanguage(name) },
      };
    };

    const config = getConfig();

    const setConfig = (newConfig) => {
      overrideConfig(newConfig);
      this.forceUpdate();
    };

    const nextWorkoutTickDelayOverride = () => {
      if (!config.workoutTickDelayOverride) {
        return 25;
      } else if (config.workoutTickDelayOverride < 6400) {
        return config.workoutTickDelayOverride * 4;
      }
    };

    const toggleAuthConfig = (value) => {
      const auth = Object.assign({}, config.auth, value);
      overrideConfig({ auth });
      this.setState({});
    };

    const buttonStyle = { backgroundColor: '#FF621D' };

    return (
      <ScrollView style={{height: '70%'}}>
        <Text>Build variant: { build.variant.name }</Text>
        <Text>Engine: { build.engine.name }</Text>

        <RadioButtonGroup
          options={[
            ...environmentToggler.getAvailableEnvironments().map(buildOption),
            {
              name: 'Cancel',
              isSelected: false,
              setOption: reset,
            },
          ]}
        />

        <Text>Locale</Text>
        <RadioButtonGroup
          options={[
            buildLocaleOption('en-AU'),
            buildLocaleOption('en-US'),
          ]}
        />

        <Text>Config (not persisted on app restarts)</Text>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => this.workoutSpeedChanged((config.workoutPlaybackSpeed || 1) % 6 + 1)}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`workout FF: ${config.workoutPlaybackSpeed || 'default'}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ showWorkoutVideo: !config.showWorkoutVideo })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`workout Vid: ${config.showWorkoutVideo}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ delayWhenLoadingWorkoutVideo: config.delayWhenLoadingWorkoutVideo > 3000 ? 6 : config.delayWhenLoadingWorkoutVideo * 5 })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`vid Load ms: ${config.delayWhenLoadingWorkoutVideo}`} />
          </View>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ workoutTickDelayOverride: nextWorkoutTickDelayOverride() })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`tick delay: ${config.workoutTickDelayOverride || 'default'}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ allowBluetoothService: !config.allowBluetoothService })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`allow BT: ${config.allowBluetoothService}`} />
          </View>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ isOrientationChecksEnabled: !config.isOrientationChecksEnabled })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`workout orient chk: ${config.isOrientationChecksEnabled}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ renderGenericMusic: !config.renderGenericMusic })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`genericMusic: ${config.renderGenericMusic}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ playWorkoutAudioTips: !config.playWorkoutAudioTips })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`AudioTips: ${config.playWorkoutAudioTips}`} />
          </View>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ enableWorkoutLeaderboardUpdates: !config.enableWorkoutLeaderboardUpdates })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`Leaderboard Updates: ${config.enableWorkoutLeaderboardUpdates}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ useNativeLoggerForDebugLogs: !config.useNativeLoggerForDebugLogs })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`native debug logs: ${config.useNativeLoggerForDebugLogs}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ profileHomeWorkoutRender: !config.profileHomeWorkoutRender })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`profile HW render: ${config.profileHomeWorkoutRender}`} />
          </View>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ workoutRenderingEnabled: !config.workoutRenderingEnabled })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`Workout rendering: ${config.workoutRenderingEnabled}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ workoutUpdateActionEnabled: !config.workoutUpdateActionEnabled })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`Workout update action: ${config.workoutUpdateActionEnabled}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ workoutUpdateReducerEnabled: !config.workoutUpdateReducerEnabled })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`Workout update reducer: ${config.workoutUpdateReducerEnabled}`} />
          </View>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ autoStartWorkout: !config.autoStartWorkout })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`autoStartWorkout: ${config.autoStartWorkout}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ autoEndWorkout: !config.autoEndWorkout })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`autoEndWorkout: ${config.autoEndWorkout}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => setConfig({ debugWorkoutInfoVisible: !config.debugWorkoutInfoVisible })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`debugWorkoutInfo: ${config.debugWorkoutInfoVisible}`} />
          </View>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => toggleAuthConfig({ facebookEnabled: !config.auth.facebookEnabled })}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`allow facebook auth: ${config.auth.facebookEnabled}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={this.cycleAgoraStreamingAudioProfile}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`StreamAudioProfile: ${config.agoraStreamingAudioProfile}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={this.cycleAgoraStreamingAudioScenario}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`StreamAudioScenario: ${config.agoraStreamingAudioScenario}`} />
          </View>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => this.changeStreamingGenericMusicVolume(config.streamingWorkoutVolume)}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`streamingGenericMVol: ${config.streamingWorkoutVolume}`} />
          </View>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => this.changeStreamingWorkoutBeepAndVoiceVolume(config.streamingWorkoutBeepAndVoiceVolume)}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`StreamingBeepAndVoiceVol: ${config.streamingWorkoutBeepAndVoiceVolume}`} />
          </View>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            <Button
              onPress={() => this.changeGenericDuckedVolume(config.streamingWorkoutDuckedVolume)}
              containerStyle={buttonStyle}
              fontSize={toggleButtonFontSize}
              title={`StreamingGenericMDuckedVol: ${config.streamingWorkoutDuckedVolume}`} />
          </View>
        </View>

        {build.variant.isElite &&
          <View>
            <Text>Elite:</Text>

            <View>
              <Button onPress={this.openSettings} title={'Open Settings'} />
            </View>
            <View style={{ flexDirection: 'row' }}>
              <View style={{ flex: 1 }}>
                <Button onPress={this.lockTask} title={'Lock Task'} />
              </View>
              <View style={{ flex: 1 }}>
                <Button onPress={this.unlockTask} title={'Unlock'} />
              </View>
            </View>
            <View>
              <Button onPress={this.resetEliteSetup} title={'Reset Elite Device Setup'} />
            </View>
            <View>
              <Button onPress={this.toggleEliteUpdateChannel} title={`Elite update channel: ${this.state.updateChannel}`} />
            </View>
          </View>
        }
      </ScrollView>
    );
  }
}

const styleSheet = StyleSheet.create({
  // copied from WorkoutScreenLandscape
  mirrorContainer: {
    width: scale(160),
    height: scale(160) * (3 / 4),
    maxWidth: 270,
    maxHeight: 270 * (3 / 4),
    alignSelf: 'center',
  },
});
